import React from 'react';
import { Card, CardContent, CardActionArea, Typography, Box } from '@mui/material';
import { Description as DocumentIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { useDateLocale } from '../hooks/useDateLocale';
import type { DocumentApproval } from '../types';
import StatusChip from './StatusChip';

interface DocumentCardProps {
  document: DocumentApproval;
}

const DocumentCard: React.FC<DocumentCardProps> = ({ document }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dateLocale = useDateLocale();

  return (
    <Card>
      <CardActionArea onClick={() => navigate(`/documents/${document.id}`)}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
            <DocumentIcon color="primary" sx={{ mt: 0.5 }} />
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
              <Typography variant="subtitle1" fontWeight={600} noWrap>
                {document.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {t(`documentType.${document.documentType}`, { defaultValue: document.documentType })}
              </Typography>
              {document.description && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }} noWrap>
                  {document.description}
                </Typography>
              )}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                <StatusChip status={document.status} />
                <Typography variant="caption" color="text.secondary">
                  {format(new Date(document.createdAt), 'd MMM yyyy', { locale: dateLocale })}
                </Typography>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default DocumentCard;
